exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-761b7a68] .el-select__tags{-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow:hidden}[data-v-761b7a68] .el-card__body{height:100%}", ""]);

// exports
